import React, { useState } from 'react';
import { LayoutElementType } from '../../layout/element-layout/layoutTypes';

import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';
interface EmptySlotWidgetProps {
  onAddElement: (type: LayoutElementType) => void;
  availableTypes: LayoutElementType[];
  slotIndex?: number;
}

export default function EmptySlotWidget({ 
  onAddElement, 
  availableTypes, 
  slotIndex 
}: EmptySlotWidgetProps) {
  const { t } = usePlatformTranslation();
  const [selectedType, setSelectedType] = useState<LayoutElementType>('stats-widget');
  const [isOpen, setIsOpen] = useState(false);

  const handleAddElement = () => {
    onAddElement(selectedType);
    setIsOpen(false);
  };

  return (
    <div className="relative h-full flex items-stretch">
      {/* Empty Slot Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full h-full bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center hover:bg-gray-100 transition-colors group"
        style={{ minHeight: 0 }}
      >
        <div className="text-center">
          <svg 
            className="w-8 h-8 text-gray-400 mx-auto mb-2 group-hover:scale-110 transition-transform" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          <span className="text-sm font-medium text-gray-600">
            {slotIndex !== undefined ? `Slot ${slotIndex + 1}` : 'Empty Slot'}
          </span>
          <span className="text-xs text-gray-500 mt-1">{t('platform.cards.widgets.click_to_add_element')}</span>
        </div>
      </button>

      {/* Dropdown for element type selection */}
      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <div className="p-3">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Select Element Type:
            </label>
            <select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value as LayoutElementType)}
              className="w-full p-2 border border-gray-300 rounded text-sm mb-3"
            >
              {availableTypes.map((type) => (
                <option key={type} value={type}>
                  {type.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase())}
                </option>
              ))}
            </select>
            <div className="flex gap-2">
              <button
                onClick={handleAddElement}
                className="flex-1 bg-blue-600 text-white px-3 py-2 rounded text-sm font-medium hover:bg-blue-700 transition-colors"
              >
                Add
              </button>
              <button
                onClick={() => setIsOpen(false)}
                className="flex-1 bg-gray-200 text-gray-800 px-3 py-2 rounded text-sm font-medium hover:bg-gray-300 transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 